import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/Api";
import { api_url_v1 } from "../utils/Config";

export const fetchSummary = createAsyncThunk(
    'summary/fetchSummary',
    async (_, { getState }) => {
        const { auth: { token } } = getState();
        try {
            const response = await api.get(`${api_url_v1}/dashboard/summary`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
);
export const fetchActiveUsersInfo = createAsyncThunk(
    'summary/fetchActiveUsersInfo',
    async (_, { getState }) => {
        const { auth: { token } } = getState();
        try {
            const response = await api.get(`${api_url_v1}/dashboard/active-users`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
);
export const fetchfetpLevelStats = createAsyncThunk(
    'summary/fetchfetpLevelStats',
    async (_, { getState }) => {
        const { auth: { token } } = getState();
        try {
            const response = await api.get(`${api_url_v1}/dashboard/fetp-levels`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
);
export const fetchAvailabityStats = createAsyncThunk(
    'summary/fetchfAvailabilityStats',
    async (_, { getState }) => {
        const { auth: { token } } = getState();
        try {
            const response = await api.get(`${api_url_v1}/dashboard/availability`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    }
);

const summarySlice = createSlice({
    name: 'summarySlice',
    initialState: {
        summary: {
            isLoading: false,
            data: {},
            error: null
        },
        activeUsers: {
            isLoading: false,
            data: [],
            error: null
        },
        fetpLevelStats: {
            isLoading: false,
            data: {},
            error: null
        },
        availabilityStats: {
            isLoading: false,
            data: {},
            error: null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSummary.pending, (state) => {
                state.summary.isLoading = true;
                state.summary.error = null;
            })
            .addCase(fetchSummary.fulfilled, (state, action) => {
                state.summary.isLoading = false;
                state.summary.data = action.payload;
                state.summary.error = null;
            })
            .addCase(fetchSummary.rejected, (state, action) => {
                state.summary.isLoading = false;
                state.summary.error = action.payload;
            })
            .addCase(fetchActiveUsersInfo.pending, (state, action) => {
                state.activeUsers.isLoading=true;
            })
            .addCase(fetchActiveUsersInfo.fulfilled,(state,action)=>{
                state.activeUsers.isLoading= false;
                state.activeUsers.data = action.payload;
            })
            .addCase(fetchActiveUsersInfo.rejected,(state,action)=>{
                state.activeUsers.isLoading = false;
                state.activeUsers.error = action.payload;
            })
            .addCase(fetchfetpLevelStats.pending, (state, action) => {
                state.fetpLevelStats.isLoading=true;
            })
            .addCase(fetchfetpLevelStats.fulfilled,(state,action)=>{
                state.fetpLevelStats.isLoading= false;
                state.fetpLevelStats.data = action.payload;
            })
            .addCase(fetchfetpLevelStats.rejected,(state,action)=>{
                state.fetpLevelStats.isLoading = false;
                state.fetpLevelStats.error = action.payload;
            })
            .addCase(fetchAvailabityStats.pending, (state, action) => {
                state.availabilityStats.isLoading=true;
            })
            .addCase(fetchAvailabityStats.fulfilled,(state,action)=>{
                state.availabilityStats.isLoading= false;
                state.availabilityStats.data = action.payload;
            })
            .addCase(fetchAvailabityStats.rejected,(state,action)=>{
                state.availabilityStats.isLoading = false;
                state.availabilityStats.error = action.payload;
            })
    }
});

export default summarySlice.reducer;